module.exports = __webpack_public_path__ + "img/home_prj_bljqr.65d50be0.jpg";